import { render, staticRenderFns } from "./TermsOfUseView.vue?vue&type=template&id=37bb841c&scoped=true&"
var script = {}
import style0 from "./TermsOfUseView.vue?vue&type=style&index=0&id=37bb841c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bb841c",
  null
  
)

export default component.exports